
interface CookieSectionProps {
  title: string;
  titleColor: string;
  children: React.ReactNode;
}

const CookieSection = ({ title, titleColor, children }: CookieSectionProps) => {
  return (
    <section>
      <h2 className={`text-xl font-bold ${titleColor} mb-4`}>{title}</h2>
      {children}
    </section>
  );
};

export default CookieSection;
